<template>
  <div class="details">
    <div class="location">
      <span>我的位置：</span>
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>产品中心</el-breadcrumb-item>
        <el-breadcrumb-item>{{name}}</el-breadcrumb-item>
        <el-breadcrumb-item v-if="names">{{names}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="productIntro">
      <el-row>
        <el-col :span="2">&nbsp;</el-col>
        <el-col :span="20">
          <div class="introL">
            <el-carousel :interval="5000" arrow="always">
              <el-carousel-item v-for="(item,index) in bannerList" :key="index">
                <img :src="settings.apiBaseImg+item" alt class="lbPic" />
              </el-carousel-item>
            </el-carousel>
          </div>
          <div class="introR">
            <div class="IntroTitle">{{list.name}}</div>
            <div class="IntroDesc">描述:{{list.describe}}</div>
            <div class="IntroModel">
              <p>整机重量：{{list.weight}}</p>
              <p>整机尺寸：{{list.size}}</p>
              <p>流量：{{list.flow}}</p>
              <p>压力：{{list.pressure}}</p>
            </div>
            <div class="application">
              <p>{{list.condition}}</p>
            </div>
          </div>
        </el-col>
        <el-col :span="2">&nbsp;</el-col>
      </el-row>
    </div>
    <div class="productDetail">
      <el-row>
        <el-col :span="2">&nbsp;</el-col>
        <el-col :span="18">
          <div class="detailTitle">
            <div class="features" v-html="list.content"></div>
          </div>
        </el-col>
        <el-col :span="2">&nbsp;</el-col>
      </el-row>
      <el-row>
        <el-col :span="2">&nbsp;</el-col>
        <el-col :span="18">
          <div class="productList">
            <ul>
              <li
                v-for="(item,index) in productList.slice(0,6)"
                @click="getData(item.id,item.name)"
              >
                <div class="productPic">
                  <img :src="settings.apiBaseImg+item.image" alt="product" />
                </div>
                <div class="productIntros">
                  <p class="productTitle">{{item.name}}</p>
                  <!-- <p class="productModel">型号：{{item.xinghao}}</p> -->
                  <!-- <p class="productPress">压力{{item.press}}bar&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp流量：{{item.flow}}</p> -->
                </div>
              </li>
            </ul>
          </div>
        </el-col>
        <el-col :span="2">&nbsp;</el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import request from "../assets/js/request.js";
import qs from "qs";
export default {
  data() {
    return {
      list: [],
      bannerList: [],
      name: "",
      names: "",
      productList: [],
      id: "",
    };
  },
  created() {
    request
      .post(
        this.settings.apiBaseUrl + "/api/index/youhuaseo",
        qs.stringify({}),
        {
          headers: {},
        }
      )
      .then((res) => {
        if (res.code == 1) {
        } else {
          this.$message.error(res.msg);
        }
      });
    request
      .post(
        this.settings.apiBaseUrl + "/api/index/add_products_look",
        qs.stringify({
          id: this.$route.query.id,
        }),
        {
          headers: {},
        }
      )
      .then((res) => {
        if (res.code == 1) {
        } else {
          this.$message.error(res.msg);
        }
      });
    if (this.$route.query.name == undefined) {
      request
        .post(
          this.settings.apiBaseUrl + "/api/index/products_type",
          qs.stringify({}),
          {
            headers: {},
          }
        )
        .then((res) => {
          if (res.code == 1) {
            this.name = res.data[0].name;
          } else {
            this.$message.error(res.msg);
          }
        });
    } else {
      this.name = this.$route.query.name;
      this.names = this.$route.query.names;
    }
    this.getData(this.$route.query.id);
  },
  methods: {
    getData(id) {
      request
        .post(
          this.settings.apiBaseUrl + "/api/index/products_view",
          qs.stringify({
            products_id: id,
          }),
          {
            headers: {},
          }
        )
        .then((res) => {
          if (res.code == 1) {
            this.list = res.data;
            this.bannerList = res.data.img_duo;
            this.getType(res.data.product_type_pid);
            this.id = res.data.product_type_pid;
            this.getProduct(this.id);
            document.body.scrollTop = document.documentElement.scrollTop = 0;
          } else {
            this.$message.error(res.msg);
          }
        });
    },
    getType(id) {
      request
        .post(
          this.settings.apiBaseUrl + "/api/index/products_type",
          qs.stringify({}),
          {
            headers: {},
          }
        )
        .then((res) => {
          if (res.code == 1) {
            for (var i = 0; i < res.data.length; i++) {
              if (res.data[i].id == id) {
                this.name = res.data[i].name;
              }
            }
          } else {
            this.$message.error(res.msg);
          }
        });
    },
    getProduct(id) {
      request
        .post(
          this.settings.apiBaseUrl + "/api/index/tuijian_productslist",
          qs.stringify({
            product_type_pid: id,
          }),
          {
            headers: {},
          }
        )
        .then((res) => {
          if (res.code == 1) {
            this.productList = res.data.rows;
          } else {
            this.$message.error(res.msg);
          }
        });
    },
  },
};
</script>

<style scoped="scoped">
.details {
  width: 100%;
  height: auto;
}

.location {
  width: 80%;
  height: 70px;
  margin: 0 auto;
  line-height: 70px;
  text-align: right;
}

.location span {
  line-height: 70px;
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #b2b2b2;
}

.location /deep/ .el-breadcrumb {
  float: right;
}

.location /deep/.el-breadcrumb__item {
  line-height: 70px;
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 400 !important;
  color: #b2b2b2;
}

.productIntro {
  width: 100%;
  height: 684px;
  background: #f8f8f8;
  padding: 40px 0;
}

.productIntro /deep/ .el-row {
  width: 100%;
  height: 100%;
}

.productIntro /deep/ .el-col-20 {
  height: 100%;
}

.productIntro .introL,
.introR {
  width: 50%;
  height: 100%;
  display: inline-block;
  box-shadow: #000000;
  box-sizing: border-box;
  float: left;
}

.introL {
  background-image: url(../assets/images/product/detailsb.png);
  background-size: 100% 100%;
}

.introR {
  padding: 120px 80px;
}

/deep/ .el-carousel {
  width: 80%;
  height: 80%;
  margin: 10% auto;
}

/deep/ .el-carousel__container {
  height: 100%;
}

.IntroTitle {
  padding-bottom: 35px;
  font-size: 24px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #252525;
  line-height: 29px;
  border-bottom: 1px solid #d9d9d9;
}

.introR .IntroDesc {
  margin-top: 46px;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #7f7f7f;
  line-height: 24px;
}

.IntroModel {
  margin-top: 50px;
  margin-bottom: 60px;
  width: 100%;
  height: 100px;
}

.IntroModel p {
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #7f7f7f;
  line-height: 28px;
}

.application {
  width: 100%;
  height: 20px;
}

.application p {
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #7f7f7f;
  line-height: 28px;
}

.productDetail {
  width: 100%;
  height: auto;
  padding-top: 40px;
}

.detailTitle {
  width: 100%;
  height: auto;
  line-height: 30px;
  margin-bottom: 40px;
}

.detailTitle img {
  vertical-align: middle;
}

.detailTitle span {
  font-size: 24px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #424242;
  vertical-align: middle;
  margin-left: 40px;
}

.features {
  width: 100%;
  height: auto;
  margin-top: 42px;
}

.features p {
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #7f7f7f;
  line-height: 24px;
}

.basicPic {
  margin-left: 50px;
  margin-top: 90px;
}

.advant {
  margin-left: 70px;
  margin-top: 30px;
}

.advant ul li {
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #7f7f7f;
  line-height: 24px;
}

.listStyle ul li {
  list-style: decimal;
}

.paramter {
  margin-left: 50px;
  margin-top: 30px;
}

.paramter ul li {
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #7f7f7f;
  line-height: 24px;
}

.field {
  margin-bottom: 200px;
}

.lbPic {
  width: 100%;
  height: 100%;
}

.productList {
  width: 100%;
  height: auto;
  clear: both;
  overflow: hidden;
  padding: 0 10px;
  box-sizing: border-box;
}

.productList ul li:nth-child(1n) {
  margin-left: 10px;
}

.productList ul li {
  width: 23%;
  /* height: 280px; */
  float: left;
  margin-right: 20px;
  transition: all 0.5s ease;
  cursor: pointer;
  margin-top: 50px;
  margin-bottom: 20px;
}

.productList ul li:nth-child(4n) {
  margin-right: 0;
}

.productPic {
  width: 100%;
  /* height: 70%; */
  clear: both;
}

.productPic img {
  width: 100%;
  height: 100%;
}

.productIntros {
  width: 100%;
  height: 30%;
  padding-left: 10px;
  transition: all 0.5s ease;
}

.productIntros .productTitle {
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #252525;
  line-height: 15px;
  padding: 20px 0 15px 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.productIntros .productModel,
.productPress {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #7f7f7f;
  line-height: 21px;
}

.productModel {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.productList ul li:hover {
  background-color: #ffffff;
  box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.1);
}

.productList ul li:hover .productIntros {
  background-color: #216bd1;
}

.productList ul li:hover .productTitle {
  color: #ffffff;
}

.productList ul li:hover .productModel {
  color: #ffffff;
}

.productList ul li:hover .productPress {
  color: #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/views/productDetails.vue